"use strict";

import axios from 'axios'
import Config from '@/config.js';
import Cookies from 'js-cookie';
import utils from './utils';
import vue from 'vue';
import router from './router'

let $this = new vue({router})

var $http = axios.create({
  baseURL: Config.server.url+Config.server.prefix,
  timeout: 55000,
  //   transformRequest: [
  //     function(data) {
  //         let ret = '';
  //         for (let it in data) {
  //             ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
  //         }
  //         ret = ret.substr(0, ret.length - 1);  
  //         return ret;
  //     }
  // ],
  withCredentials: true,
});

$http.defaults.withCredentials=true;

$http.interceptors.request.use(
  config => {
      if (Cookies.get('park_token')) {
        config.headers['Authorization'] = 'Bearer '+Cookies.get('park_token');
      }
      return config;
  }
)


//清除toekn方法

const clearToken = ()=>{
    //清token
    utils.notice("登录失效", 'info');
    Cookies.set('park_token', '');
    setTimeout(()=>{
        window.location.reload();
    },1000)
}

//登录失效计数器
let failCount = 0;


$http.interceptors.response.use(
  response => {
    //console.log(response, 'response111')
    if (response.data.type=='application/json'){
        let codeData
        var reader = new FileReader()
        reader.onload = e => {
            codeData = JSON.parse(e.target.result);
            if(codeData.code == 401){
                // if (count == 1) {
                //     return handleRefresh(response)
                // } else {
                //     return handleOtherRefresh(response)
                // }
                failCount++;
                if (failCount == 1) {
                    clearToken();
                }

                return;
            }
        }
        reader.readAsBinaryString(response.data)
    } else if (response.data.code == 403) {
        $this.$router.push({
            name: 'page-403'
        })
    }else if(response.data.code == 401){
    //   if (count==1) {
    //     return handleRefresh(response)
    //   }else{
    //      return handleOtherRefresh(response)
    //   }
        failCount++;
        if (failCount == 1) {
            clearToken();
        }

        return;
    } else if (response.data.code == 1001) {
        failCount++;
        if(failCount == 1){
            clearToken();
        }

        return;
    }
    return response.data;
  },
  error => { //这是异常
    if (error.response) {   
      const code = error.response.status;
      if (code == 401) {
        // Cookies.set('token', '');
        // utils.notice("认证失败，请重新登录", 'error');
      }
      if (code == 500) {
        utils.notice("接口错误，请联系管理员", 'error');
      }
      if (code == 404) {
        utils.notice("404 NOT FOUND", 'error');
      }
      if (code == 422) {

        
        // for (var name in error.response.data) {
        //   let msg = (error.response.data[name][0]);
        //   utils.notice(`数据验证未通过 -- ${msg}`, 'error');
        //   break;
        // }
      }
    }
    return Promise.reject(error)
  }
);

export default $http;